export default "__VITE_ASSET__59c6f163__"